module.exports = __webpack_public_path__ + "img/UserScientificDegrees.dc695489.svg";